import TasksProvider from "context/admin/tasks";

import { CreateTaskModal } from "page_components/admin/modals";

const CreateTask = ({ isOpen, onClose }) => {
  return (
    <TasksProvider>
      <CreateTaskModal isOpen={isOpen} onClose={onClose} />
    </TasksProvider>
  );
};

export default CreateTask;
